import script from "./tab-noraml.vue?vue&type=script&setup=true&lang=js"
export * from "./tab-noraml.vue?vue&type=script&setup=true&lang=js"

import "./tab-noraml.vue?vue&type=style&index=0&id=298177e4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-298177e4"]])

export default __exports__